import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import * as React from 'react';
import { SectionFieldOption, SectionFieldContainerProps, TemplateScoreContextType } from '../../typings';
import useStyles from '../../styles/componentStyle';
import { TemplateScoreContext } from '../../contexts/TemplateScoreContext';
import LinkFormsWeb from './LinkFormsWeb';
import LinkFormsMobile from './LinkFormsMobile';

const SingleSelect: React.FC<SectionFieldContainerProps> = (singleSelectProps) => {
  const templateScoreContext = React.useContext<TemplateScoreContextType>(TemplateScoreContext);
  const classes = useStyles();
  const { isMobile, sectionFieldDetails, sectionRank } = singleSelectProps;
  const { name, isMandatory, selectOptions, rank, extra } = sectionFieldDetails;
  if (extra?.source === 'forms') {
    return isMobile ? <LinkFormsMobile {...singleSelectProps} /> : <LinkFormsWeb {...singleSelectProps} />;
  }
  // Initialize with the default option if any, otherwise use rank 0
  const [singleValue, setSingleValue] = React.useState<number>(
    () => selectOptions?.find((option: SectionFieldOption) => option.isDefault)?.rank ?? 0
  );
  const usedForScore = extra?.usedForScore ?? false;
  const hasEmptyOption = selectOptions?.length === 0;
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedRank = event.target.value as number;
    const selectedOption = selectOptions?.find((option) => option.rank === selectedRank);
    const score = selectedOption?.score ?? 0;
    templateScoreContext.updateTemplateScoreMap(sectionRank, rank, score, usedForScore);
    setSingleValue(selectedRank);
  };
  return (
    <FormControl fullWidth variant='outlined' size={isMobile ? 'small' : 'medium'} required={isMandatory}>
      <InputLabel classes={{ root: classes.inputLabel }} id='single-select-outlined-label'>
        {name}
      </InputLabel>
      <Select
        label={name}
        labelId='single-select-outlined-label'
        value={hasEmptyOption ? null : singleValue}
        onChange={handleChange}
        disabled={hasEmptyOption}
      >
        {selectOptions?.map((eachOption: SectionFieldOption) => (
          <MenuItem value={eachOption.rank} key={eachOption.rank}>
            {eachOption.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SingleSelect;
